<template>
  <v-app light>
    <Header />

    <!-- 以下router.jsによって切り替えるView -->
    <router-view/>
  </v-app>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "App",
  data() {
    return {};
  },
  components: {
    Header,
  }
};
</script>
